import Axios from "axios";
import QueryOptions from "../sal-ui/QueryOptions";
import PagedResult from "./PagedResult";
import AiProviderConnection from "../domain/AiProviderConnection";

class AiProviderConnectionService {

    readonly basePath = "/ai-provider-connections";

    public add(aiProviderConnection: AiProviderConnection): Promise<string> {
        return Axios.post(`${this.basePath}`, aiProviderConnection).then(value => value.data.id);
    }

    public update(id: string, aiProviderConnection: AiProviderConnection): Promise<void> {
        return Axios.put(`${this.basePath}/${id}`, aiProviderConnection);
    }

    public get(id: string): Promise<AiProviderConnection> {
        return Axios.get(`${this.basePath}/${id}`)
            .then(value => AiProviderConnection.fromPOJO(value.data));
    }

    public delete(aiProviderConnection: AiProviderConnection): Promise<void> {
        return Axios.delete(`${this.basePath}/${aiProviderConnection.id}`);
    }

    public getList(queryOptions: QueryOptions): Promise<PagedResult<AiProviderConnection>> {
        const query = queryOptions.toQueryParams();

        return Axios.get(`${this.basePath}?${query}`)
            .then(value => new PagedResult(
                value.data.total,
                value.data.data.map((objectJson: object) => AiProviderConnection.fromPOJO(objectJson))
            ));
    }
}

export default AiProviderConnectionService;
